// 投标平台询比接口
import request from '@/utils/request'
import useMaterialInquiry from '@/components/common/PurchaseListComponent/useMaterialInquiry'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 询比单详情信息查询
export function getInquiryDetailApi(ids) {
  const { orderId } = ids
  return request({
    url: baseUrl + `/workbench/supplier/inquiry-orders/${orderId}/detail`,
    methods: 'get'
  })
}

// 查询邀请函询比单信息
export function getInquiryInviteDetailApi(ids) {
  const { orderId, inviteId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/invites/${inviteId}/detail`,
    methods: 'get'
  })
}

// 获取供应商询比交易信息
export function getInquiryTradeApi(ids) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}`,
    method: 'get'
  })
}

// 获取供应商询比交易信息v2 --- 增加在线签章
export function getInquiryTradeV2api(ids) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/offer/${orderId}/trades/${tradeId}/detail`,
    method: 'get'
  })
}

// 供应商报名
export function postApplyInfoApi(ids, data) {
  const { orderId } = ids
  return request({
    url:
      baseUrl + `/workbench/supplier/inquiry-orders/${orderId}/trades/sign-up`,
    method: 'post',
    data
  })
}

export function putApplyInfoApi(ids, data) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/sign-up`,
    method: 'put',
    data
  })
}

// 查询某个轮次下的报价信息，
// TODO: 待小程序也不适用时删除
export function getQuoteInRoundApi(ids) {
  const { orderId, tradeId, roundId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/rounds/${roundId}`,
    method: 'get'
  })
}

// 查询某个轮次下的有效报价信息
export function getEfficientQuoteInRoundApi({ orderId, tradeId, roundId }) {
  return request({
    url: `${baseUrl}/workbench/supplier/inquiry-orders/offer/effective/${orderId}/trades/${tradeId}/rounds/${roundId}`,
    method: 'get'
  }).then(res => {
    if (res.data) res.data = useMaterialInquiry().changeQuoteResData(res.data)
    return res
  })
}

// 查询某个轮次下的无效报价信息 (即保存状态的报价）
export function getInvalidQuoteInRoundApi({ orderId, tradeId, roundId }) {
  return request({
    url: `${baseUrl}/workbench/supplier/inquiry-orders/offer/latest/${orderId}/trades/${tradeId}/rounds/${roundId}`,
    method: 'get'
  }).then(res => {
    if (res.data) res.data = useMaterialInquiry().changeQuoteResData(res.data)
    return res
  })
}

// 修改报价时调用的接口，后端生成一份编辑状态的报价副本
export function generateEditQuotationCopyApi({ orderId, tradeId, roundId }) {
  return request({
    url: `${baseUrl}/workbench/supplier/inquiry-orders/offer/${orderId}/trades/${tradeId}/rounds/${roundId}/leave-offer`,
    method: 'get'
  })
}

// 提交报价
export function postQuoteApi(ids, data) {
  const { orderId, tradeId, roundId, offerId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/rounds/${roundId}/offers/${offerId}`,
    method: 'post',
    data: useMaterialInquiry().changeQuotePostData(data)
  })
}

// 报名费-业务请求下单
export function payApplyFeeApi({ ids }) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/sign-up-fee-order`,
    method: 'post'
  })
}

// 支付报名费结果查询
export function payApplyFeeResultApi(params) {
  const { orderCode } = params
  return request(
    {
      url:
        baseUrl + `/workbench/supplier/inquiry-orders/sign-up-pay/${orderCode}`,
      method: 'get'
    },
    false
  )
}

// 查询保证金账户信息
export function getGuaranteeFeeAccountApi(ids) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/refresh-account`,
    method: 'get'
  })
}

/**
 * 供应商预览报价文件
 * @param params
 * @param {string|number} params.orderId 项目id
 * @param {string|number} params.tradeId 交易id
 * @param {string|number} params.attachmentId 附件id
 * @param {string|number} params.offerId 报价单id
 * @param {bool} params.isSignFile 是否是签章文件
 * @param {string|number} params.fileType 3报价单，4其他报价附件
 * @param {bool} params.isRelease 文件是否已发布
 * @returns {Promise<void>|*}
 */
export function previewQuoteFileInSupplierApi(params) {
  return request({
    url: baseUrl + `/workbench/supplier/inquiry-orders/preview-offer-file`,
    method: 'get',
    params
  })
}

/**
 * 供应商下载报价文件
 * @param params
 * @param {string|number} params.orderId 项目id
 * @param {string|number} params.tradeId 交易id
 * @param params.pattern 模式选择
 * @param {string|number} params.attachmentId 附件id
 * @param {string|number} params.offerId 报价单id
 * @param {bool} params.isSignFile 是否是签章文件
 * @param {string|number} params.fileType 3报价单，4其他报价附件
 * @param {bool} params.isRelease 文件是否已发布
 * @returns {Promise<void>|*}
 */
export function downloadQuoteFileInSupplierApi(params) {
  const { orderId } = params
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/download-offer-file`,
    method: 'get',
    params
  })
}

// 签章文件预览鉴权
// params: {orderId， tradeId, fileId, pattern}
export function previewQuoteFileApi(params) {
  return request({
    url: `${baseUrl}/workbench/supplier/inquiry-orders/offer/preview-offer-signature-file`,
    method: 'get',
    params
  })
}

// 签章文件下载鉴权
// { orderId, tradeId, fileId }
export function downloadQuoteFileApi(params) {
  return request({
    url: `${baseUrl}/workbench/supplier/inquiry-orders/offer/download-offer-signature-file`,
    method: 'get',
    params
  })
}

// 接受邀请
export function acceptInviteApi(ids, data) {
  const { orderId, inviteId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/invites/${inviteId}/accept`,
    method: 'post',
    data
  })
}

// 拒绝邀请
export function rejectInviteApi(ids) {
  const { orderId, inviteId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/invites/${inviteId}/refuse`,
    method: 'post'
  })
}

// 业务请求下单-服务费
export function postServiceFeePayApi({ ids }) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/service-fee-order`,
    method: 'post'
  })
}

// 轮询服务费支付结果
export function getServiceFeePayResultApi(params) {
  const { orderCode } = params
  return request(
    {
      url:
        baseUrl +
        `/workbench/supplier/inquiry-orders/service-fee-pay/${orderCode}`,
      method: 'get'
    },
    false
  )
}

// 保证金退回申请
export function postInquiryGfBackApi(params = {}, ids) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/gf-pay-back`,
    method: 'post',
    params
  })
}

// 查询变更列表
export function getChangeNoticeListApi(ids) {
  const { orderId } = ids
  return request({
    url:
      baseUrl + `/workbench/supplier/inquiry-orders/${orderId}/change-notices`,
    method: 'get'
  })
}

// 查询已关闭候选列表
export function getClosedCandidateListApi(ids) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/close/candidates`,
    method: 'get'
  })
}

// 查询已关闭候选详情
export function getClosedCandidateInfoApi(ids) {
  const { orderId, tradeId, candidateId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/close/candidates/${candidateId}/detail`,
    method: 'get'
  })
}

// 查询已关闭成交列表
export function getClosedWinnerListApi(ids) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/close/winners`,
    method: 'get'
  })
}

// 查询已关闭成交详情
export function getClosedWinnerInfoApi(ids) {
  const { orderId, tradeId, winnerId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/close/winners/${winnerId}/detail`,
    method: 'get'
  })
}

// 品目报价导入
export function importQuoteInfoApi(data) {
  return request(
    {
      url: baseUrl + '/workbench/template/materiel-offer/import',
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

// 含税品目报价导入
export function importRequireTaxQuoteInfoApi(data) {
  return request(
    {
      url: baseUrl + '/workbench/template/materiel-offer-rate/import',
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

// 查询供应商的证件要求列表
export function getInquiryRequireListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/owner-cert-require`,
    method: 'get'
  })
}

// 获取澄清文件列表
export function getSupplementListApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${params.orderId}/trades/${params.tradeId}/file-supplements`,
    method: 'get'
  })
}

// 预览询比文件
export function previewSupplierInquiryFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${params.orderId}/preview-supplement-file`,
    method: 'get',
    params
  })
}

// 下载询比文件
export function downloadSupplierInquiryFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${params.orderId}/download-supplement-file`,
    method: 'get',
    params
  })
}

// 下载询比文件
export function getDownloadSupplierInquiryFileApi(params) {
  const { orderId, ...other } = params
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/download-inquiry-file`,
    method: 'get',
    params: other
  })
}

// 预览询比文件
export function getPreviewSupplierInquiryFileApi(params) {
  const { orderId, ...other } = params
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/preview-inquiry-file`,
    method: 'get',
    params: other
  })
}

// 确认使用会员保证金额度抵扣
export function useInquiryGuaranteeVipPayApi(orderId, tradeId, data) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/deposit-quota`,
    method: 'post',
    data
  })
}
